var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterDataManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64112 2.65171L4.0084 3.89305C2.328 4.34331 1.61325 5.58939 2.06499 7.27532L3.595 12.9854C4.05415 14.6989 5.29025 15.3986 6.97066 14.9483L11.6034 13.707C13.3109 13.2495 14.0039 12.0329 13.5447 10.3193L12.0147 4.60929C11.563 2.92336 10.3486 2.19419 8.64112 2.65171Z",
    fill: "url(#paint0_linear_9308_7447)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9308_7447)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.47119,
    y: 12.9565,
    width: 7.39047,
    height: 6.25834,
    rx: 2.23887,
    transform: "rotate(-105 5.47119 12.9565)",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.61067,
    y: 1.76863,
    width: 17.9769,
    height: 19.1214
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.92px)",
      clipPath: "url(#bgblur_0_9308_7447_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 3.83806,
    d: "M12.9975 5.60669H8.20132C6.46164 5.60669 5.44873 6.62532 5.44873 8.37072V14.2822C5.44873 16.0562 6.46164 17.052 8.20132 17.052H12.9975C14.7652 17.052 15.7495 16.0562 15.7495 14.2822V8.37072C15.7495 6.62532 14.7652 5.60669 12.9975 5.60669Z",
    fill: "#BA90FF",
    fillOpacity: 0.35
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.45912,
    y: 5.86928,
    width: 10.2285,
    height: 10.9018
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.2px)",
      clipPath: "url(#bgblur_1_9308_7447_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7447)",
    "data-figma-bg-blur-radius": 2.39879
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3562 13.4702H12.8425C13.0709 13.4931 13.2429 13.6877 13.2429 13.9224C13.2428 14.1506 13.0708 14.3458 12.8425 14.3687H8.3562C8.18452 14.3915 8.01808 14.3057 7.92651 14.1626C7.83508 14.014 7.83526 13.8251 7.92651 13.6821C8.01808 13.5333 8.18452 13.453 8.3562 13.4702ZM12.8425 10.8599C13.0886 10.8599 13.2888 11.0611 13.2888 11.3071C13.2886 11.553 13.0884 11.7534 12.8425 11.7534H8.3562C8.10969 11.7534 7.91012 11.553 7.90991 11.3071C7.90991 11.0611 8.10956 10.8599 8.3562 10.8599H12.8425ZM10.0662 8.26807C10.3128 8.26807 10.5134 8.46885 10.5134 8.71436C10.5132 8.9665 10.3127 9.1665 10.0662 9.1665H8.3562C8.10957 9.1665 7.90994 8.96627 7.90991 8.72021C7.90991 8.47414 8.10956 8.27393 8.3562 8.27393V8.26807H10.0662Z",
    fill: "url(#paint1_linear_9308_7447)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7447",
    x: -0.256786,
    y: 0.382862,
    width: 15.5883,
    height: 16.3888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.15891,
    result: "effect1_foregroundBlur_9308_7447"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7447_clip_path",
    transform: "translate(-1.61067 -1.76863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9975 5.60669H8.20132C6.46164 5.60669 5.44873 6.62532 5.44873 8.37072V14.2822C5.44873 16.0562 6.46164 17.052 8.20132 17.052H12.9975C14.7652 17.052 15.7495 16.0562 15.7495 14.2822V8.37072C15.7495 6.62532 14.7652 5.60669 12.9975 5.60669Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7447",
    x: 5.45912,
    y: 5.86928,
    width: 10.2285,
    height: 10.9018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.799597,
    dy: 0.799597
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.799597
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.577356 0 0 0 0 0.359375 0 0 0 0 0.9375 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7447",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7447_clip_path",
    transform: "translate(-5.45912 -5.86928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3562 13.4702H12.8425C13.0709 13.4931 13.2429 13.6877 13.2429 13.9224C13.2428 14.1506 13.0708 14.3458 12.8425 14.3687H8.3562C8.18452 14.3915 8.01808 14.3057 7.92651 14.1626C7.83508 14.014 7.83526 13.8251 7.92651 13.6821C8.01808 13.5333 8.18452 13.453 8.3562 13.4702ZM12.8425 10.8599C13.0886 10.8599 13.2888 11.0611 13.2888 11.3071C13.2886 11.553 13.0884 11.7534 12.8425 11.7534H8.3562C8.10969 11.7534 7.91012 11.553 7.90991 11.3071C7.90991 11.0611 8.10956 10.8599 8.3562 10.8599H12.8425ZM10.0662 8.26807C10.3128 8.26807 10.5134 8.46885 10.5134 8.71436C10.5132 8.9665 10.3127 9.1665 10.0662 9.1665H8.3562C8.10957 9.1665 7.90994 8.96627 7.90991 8.72021C7.90991 8.47414 8.10956 8.27393 8.3562 8.27393V8.26807H10.0662Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7447",
    x1: 6.32448,
    y1: 3.27245,
    x2: 9.28674,
    y2: 14.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8237FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8237FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7447",
    x1: 12.9038,
    y1: 9.37035,
    x2: 6.85321,
    y2: 9.54586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterDataManage);
export default __webpack_public_path__ + "static/media/masterDataManage.827ee90808f08060abf7a3d6255acfe2.svg";
export { ForwardRef as ReactComponent };